import { mapState, mapActions } from 'vuex';
import {
  Component, Vue, Watch, Mixins, Prop, Ref,
} from 'vue-property-decorator';
import firebase from '@/plugins/firebase';

@Component({
  name: 'SignInWithEmailLinkView',
})
export default class SignInWithEmailLinkView extends Vue {
  step = 1;

  confirming = false;

  // email = '';
  // emailRules = [
  //   (v: string) => !!v || 'E-mail is required',
  //   (v: string) => /.+@.+\..+/.test(v) || 'E-mail must be valid'
  // ]
  get secret() {
    return this.$route.query.secret;
  }

  get signin() {
    return this.$route.query.signin;
  }

  get emailCode() {
    return this.$route.query.emailCode;
  }

  proofs: any = {}

  confirm() {
    this.confirming = true;
    this.$auth.authenticate({ id: this.signin, emailCode: this.emailCode }).then((result: boolean | any) => {
      if (result === true) {
        this.step = 3;
      } else {
        Object.entries(result).forEach(([key, value]) => {
          this.proofs[key] = value;
        });
        this.step = 2;
      }
    }).catch(error => this.$alert(error)).finally(() => {
      this.confirming = false;
    });
  }

  close() {
    window.close();
  }
}
